angular.module('admin.articles.index', [
  'directives.paginator',
  'security.authorization',
  'services.utility',
  'services.search',
  'services.adminResource',
  'services.localizedMessages',
]);

angular.module('admin.articles.index').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.articles', {
      url: '/articles',
      title: 'Manage Articles',
      views: {
        'main@': {
          template: require('../../common/templates/articles.tpl.html'),
          controller: 'ArticlesIndexCtrl'
        }
      }
    });
}]);

angular.module('admin.articles.index').controller('ArticlesIndexCtrl',
  ["$scope", "$rootScope", "$route", "$location", "$log", "utility", "searchService", "STATUSES", "adminResource", "articles", "localizedMessages", function($scope, $rootScope, $route, $location, $log, utility, searchService, STATUSES, adminResource, articles, localizedMessages) {
    $scope.localizedMessages = localizedMessages;
    STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
    searchService.setSearchFn(adminResource.searchArticles);

    searchService.setRedirectBase('/admin/articles');

    // local var
    var deserializeData = function(data) {
      $scope.page = data.meta.page;
      $scope.query = data.meta.query;
      $scope.articles = data.data.map(function(article){
        article.title = _.unescape(article.title);
        article.title = article.title.replace(/&#039;/g, "'"); // TO DO tmp fix as unescape does not process this characters
        return article;
    });
    };

    $scope.query = {};
    //select elements and their associating options
    $scope.statuses = STATUSES;
    $scope.sorts = [
      {label: "id \u25B2", value: "_id"},
      {label: "id \u25BC", value: "-_id"},
      {label: "article_id \u25B2", value: "article_id"},
      {label: "article_id \u25BC", value: "-article_id"},
      {label: "name \u25B2", value: "name"},
      {label: "name \u25BC", value: "-name"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];

    $scope.$watchCollection('query', function(newState, oldState) {
      if ( angular.equals(newState, oldState) ) {
        return;
      }

      adminResource.findArticles($scope.query).then(function(data) {
        deserializeData(data);
        //update url in browser addr bar
        $location.search($scope.query);
      }, function(e) {
        $log.error(e);
      });
    });

    $scope.fetchArticles = function(offset) {
      $scope.query.skip = offset;
    };

    $scope.getLabel = function (status) {
      return _.find(STATUSES, {id: status + ''}).value;
    };

    $scope.getStyle = function (status) {
      var status = _.find(STATUSES, {id: status + ''});
      return {
        color: status.color,
        background: status.background
      }
    };


    //initialize $scope variables
    deserializeData(articles);
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/articles/articles.js